import React from 'react'
import BulkTransactionsButtons from './Buttons'

function BulkTransactions(): React.ReactElement {
  return (
    <div className="p-12 bg-white content-container">
      <div className="flex flex-col lg:flex-row lg:justify-between gap-2">
        <div>
          <h3>
            <span className="tracking-wider font-bold text-xl">Bulk Transactions</span>
          </h3>
          <p>
            <span className="tracking-wider font-light">
              Perform bulk transactions on multiple cards at once.
            </span>
          </p>
          <br />
          <p>
            <BulkTransactionsButtons />
          </p>
        </div>
      </div>
    </div>
  )
}

export default BulkTransactions
